import React from 'react';

interface ActionBarProps {
  children: React.ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right' | 'between' | 'stretch';
  spacing?: 'sm' | 'md' | 'lg';
  orientation?: 'horizontal' | 'vertical';
}

export function ActionBar({ 
  children, 
  className = '', 
  align = 'right',
  spacing = 'md',
  orientation = 'horizontal'
}: ActionBarProps) {
  const alignmentClasses = {
    left: 'justify-start',
    center: 'justify-center', 
    right: 'justify-end',
    between: 'justify-between',
    stretch: 'justify-stretch'
  };

  const spacingClasses = {
    sm: 'gap-2',
    md: 'gap-3', 
    lg: 'gap-4'
  };

  const orientationClasses = {
    horizontal: 'flex-row',
    vertical: 'flex-col'
  };

  return (
    <div className={`flex items-center ${orientationClasses[orientation]} ${alignmentClasses[align]} ${spacingClasses[spacing]} ${className}`}>
      {children}
    </div>
  );
}